import {ESprintenTeam} from '@repo/shared/Customer/Coop/SprintenTeams/SprintenTeams.types'

export enum EMessageType {
  Error = 'error',
  Pong = 'pong',
  Info = 'info',
  Leaderboard = 'leaderboard',
  GameStarted = 'gameStarted',
  EndPosition = 'endPosition',
  GameEnded = 'gameEnded',
}
export interface IPongMessage {
  type: EMessageType.Pong
}

export interface IInfoMessage {
  type: EMessageType.Info
  game: string
  gameCode: number
  hasStarted: boolean
  playerCount: number
  serverTime: number
  hash: string
  teams: ESprintenTeam[]
}

interface ILeaderboardItem {
  clicks: number
  playerId: string
}

export type TSlot = 1 | 2 | 3 | 4 | 5
export type TPosition = 1 | 2 | 3 | 4 | 5
export interface ILeaderboardTeamItem {
  clicks: number
  percentage: number
  team: ESprintenTeam
  slot: TSlot
  playerCount: number
}

export interface ILeaderboardMessage {
  type: EMessageType.Leaderboard
  leaderboard: ILeaderboardItem[]
  leaderboardTeams: ILeaderboardTeamItem[]
  totalClients: number
  totalTeams: number
}

export interface IGameStartedMessage {
  type: EMessageType.GameStarted
  countdownFromSeconds: number
  startTime: number
}

export interface IEndPositionMessage {
  type: EMessageType.EndPosition
  team: ESprintenTeam
  slot: TSlot
  position: TPosition
}

export interface IGameEndedMessage {
  type: EMessageType.GameEnded
  winner: string
}

export interface IErrorMessage {
  type: EMessageType.Error
  message: string
}

export type WebSocketMessageMap = {
  [EMessageType.Pong]: IPongMessage
  [EMessageType.GameStarted]: IGameStartedMessage
  [EMessageType.Info]: IInfoMessage
  [EMessageType.GameEnded]: IGameEndedMessage
  [EMessageType.EndPosition]: IEndPositionMessage
  [EMessageType.Leaderboard]: ILeaderboardMessage
  [EMessageType.Error]: IErrorMessage
}

export type TWebSocketMessage = WebSocketMessageMap[keyof WebSocketMessageMap]
